import React, {FC} from "react"
import {Col, Row} from "react-bootstrap"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {CompanyNewsTileConfig} from "@irati/types"
import {Description, ImageUploader, Url} from "@irati-web/fields/companyNews"

interface Props extends InjectIntl {
  companyNewsTileConfig: CompanyNewsTileConfig,
  imageError?: string,
  removeImageError: () => void,
  updateContent: (companyNewsTileConfig: CompanyNewsTileConfig) => void
}

const NewImageForm: FC<Props> = ({companyNewsTileConfig, formatMessage, imageError, removeImageError, updateContent}) => (
  <Row>
    <Col xs={6}>
      <ImageUploader
        error={imageError}
        help={formatMessage({id: "platform.homepage.fields.image.description"})}
        imageUrl={companyNewsTileConfig.imageUrl}
        message={formatMessage({id: "platform.homepage.fields.image.label"})}
        onUploadSuccess={(imageUrl: string) => {
          updateContent(Object.assign({}, companyNewsTileConfig, {imageUrl}))
          removeImageError()
        }} />
    </Col>
    <Col xs={6}>
      <Description
        onChange={(message: string) => {
          const updatedContent = Object.assign({}, companyNewsTileConfig, {message})
          updateContent(updatedContent)
        }}
        value={companyNewsTileConfig.message} />
      <Url
        onChange={(url: string) => {
          updateContent(Object.assign({}, companyNewsTileConfig, {url}))
        }}
        value={companyNewsTileConfig.url} />
    </Col>
  </Row>
)

export default injectIntl(NewImageForm)
